import { render, staticRenderFns } from "./Module2.vue?vue&type=template&id=01e1a7d5&"
import script from "./Module2.vue?vue&type=script&lang=js&"
export * from "./Module2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports